<div class="app_ui_titlebar">
  <div class="app_ui_label">
    IDENTY
  </div>
  <div class="app_ui_options">
    <app-title-context-menu></app-title-context-menu>
  </div>
</div>
